import { render, staticRenderFns } from "./SuccessApply.vue?vue&type=template&id=5a82fed0"
import script from "./SuccessApply.vue?vue&type=script&lang=js"
export * from "./SuccessApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports